package com.evoapps.evoshift.ui.adaptive

import androidx.compose.runtime.Composable

/**
 * SH-102: the web app keeps its ordinary layouts. (The Device Posture API exists only in some
 * Chromium builds and reports no hinge position, so it is not used.)
 */
@Composable
actual fun rememberPlatformDevicePosture(): DevicePosture = DevicePosture.Normal
